import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChildren,
} from "@angular/core";
import { FormControl, UntypedFormArray, UntypedFormBuilder } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Hotel } from "@core/models";
import { SearchConfig } from "@interfaces";
import {
  NgbDateParserFormatter,
  NgbDropdown,
} from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { CompanyService, NgxToastrService, TravelService, UserService, UtilsService } from "@services";
import { CustomDateParserFormatter } from "@shared/component/date-parser";
import { DialogAssignProjectComponent } from "@shared/component/dialog-assign-project/dialog-assign-project.component";
import moment from "moment";
import { catchError, forkJoin, of, Subscription, tap } from "rxjs";

// @ts-ignore
@Component({
  selector: "app-search-form",
  templateUrl: "./search-form.component.html",
  styleUrls: ["./search-form.component.scss"],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class SearchFormComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() openModal = false;
  @Input() isOnDetails = false;
  @Input() userToBook: any;
  @Input() companyUuid: string;
  @Input() firstSearch = true;
  @Input() hotelsMapCopy: Hotel[];
  @Input() hotelsListCopy: Hotel[];
  @Input() uuidUser: any;
  @Input() travelersSelected: any;
  @Input() travelersAndRoomsSelected: any;
  @Input() projectDataSaved: any;
  @Input() isAdmin: any;
  @Input() userFilters: any;
  @Input() searchConfig: SearchConfig = {
    uuid: "",
    locationText: "",
    latitude: "",
    longitude: "",
    checkIn: null,
    minElements: "0",
    checkOut: null,
    occupancies: [
      {
        rooms: 1,
        adults: 1,
        paxes: [],
      },
    ],
  };

  roomModalOpen = false;
  date = new Date();
  minDateNgStruct = {
    year: this.date.getFullYear(),
    month: this.date.getMonth() + 1,
    day: this.date.getDate(),
  };
  maxDateNgStruct = {
    year: this.date.getFullYear() + 20,
    month: this.date.getMonth() + 1,
    day: this.date.getDate(),
  };
  formRoom: any;
  rooms = [];
  isPackageRate: string;
  guests: any[] = [];
  guestsNumber: number = 0;
  opened: boolean[][] = [[false], [false], [false]];
  @ViewChildren(NgbDropdown) dropdown: NgbDropdown;

  @Output() emitData = new EventEmitter<any>();
  @Output() emitSelectedUsers = new EventEmitter<any>();
  @Output() emitSelectedTravelers = new EventEmitter<any>();
  @Output() emitProject = new EventEmitter<any>();
  @Output() emitPackageRate = new EventEmitter<any>();

  defaultUser: any;
  travelers: string[][] = [];
  companyUsers: { name: string; lastname: string; uuid: string }[] = [];
  selectedUsers: any;
  public filterControl = new FormControl();
  public filteredUsers: { name: string; lastname: string; uuid: string }[];
  projects: any[];
  selectedProject: any = null;
  loadingProjects: boolean = false;
  selectedTraveler: { [key: number]: string | null } = {};
  subcriptions: Subscription[] = [];
  policies: any[] = [];
  loadingPolicies: boolean = false;
  private userPoliciesCache: { [userUuid: string]: any[] } = {};
  @Input() selectedPolicy: any = null;
  @Output() emitSelectedPolicy = new EventEmitter<any>();
  private policiesSub?: Subscription;
  private lastPoliciesRequestKey: string | null = null;

  constructor(
    private ngxToastrService: NgxToastrService,
    public translate: TranslateService,
    private formBuilder: UntypedFormBuilder,
    public utilsService: UtilsService,
    private companyService: CompanyService,
    private userService: UserService,
    private travelService: TravelService,
    private dialog: MatDialog,
  ) {
    this.formRoom = this.formBuilder.group({
      room: this.formBuilder.array([
        {
          idHab: 1,
          numAdults: 1,
        },
      ]),
    });
    if(this.firstSearch && !this.openModal) {
      this.searchConfig = {
        uuid: "",
        locationText: "",
        latitude: "",
        longitude: "",
        checkIn: null,
        minElements: "0",
        checkOut: null,
        occupancies: [
          {
            rooms: 1,
            adults: 1,
            paxes: [],
          },
        ],
      };
    }
  }

  ngOnInit() {
    this.isPackageRate = localStorage.getItem("isPackageRate")
    if(this.firstSearch && !this.openModal) {
      this.searchConfig = {
        uuid: "",
        locationText: "",
        latitude: "",
        longitude: "",
        checkIn: null,
        minElements: "0",
        checkOut: null,
        occupancies: [
          {
            rooms: 1,
            adults: 1,
            paxes: [],
          },
        ],
      };
    }
    this.getCompanyUsers();
    this.utilsService.clearProcessedUuids();
    this.utilsService.clearProjectData();

    if(this.projectDataSaved){
      this.projects = this.projectDataSaved.allProjects;
      this.selectedProject = this.projectDataSaved.selectedProject;
    }

    if (this.travelersAndRoomsSelected && this.travelersAndRoomsSelected.length > 0) {
      this.travelers = this.travelersAndRoomsSelected.map(room => [...room]);
      this.travelers.forEach((room, i) => {
        this.selectedTraveler[i] = room.length > 0 ? room[0] : null;
      });
    }
    if (this.travelers && this.travelers.length > 0) {
      this.loadPoliciesForCurrentTravelers();
    }
  }

  ngAfterViewInit() {}

  getInMaxDate() {
    return this.utilsService.getInDate(
      this.maxDateNgStruct,
      this.searchConfig.checkOut
    );
  }

  getOutMinDate() {
    const minDateWithAdvance = this.getInMinDate();
    return this.utilsService.getOutDate(
      minDateWithAdvance,
      this.searchConfig.checkIn
    );
  }

  getOutMaxDate() {
    const maxDate = moment(this.searchConfig.checkIn).add(28, 'days')
    return {
      year: maxDate.year(),
      month: maxDate.month(),
      day: maxDate.date(),
    };
  }
 
  getInMinDate() {
    const daysInAdvance = this.isAdmin ? 0 : (this.userFilters?.hotelDaysInAdvance || 0);
    const minDate = moment().add(daysInAdvance, 'days');
    return {
      year: minDate.year(),
      month: minDate.month() + 1,
      day: minDate.date(),
    };
  }

  getAddress(place: object) {
    if (place["geometry"]) {
      this.searchConfig.locationText = place["formatted_address"];
      this.searchConfig.latitude = place["geometry"]["location"]
        .lat()
        .toString();
      this.searchConfig.longitude = place["geometry"]["location"]
        .lng()
        .toString();
    } else {
      this.searchConfig.latitude = "";
      this.searchConfig.longitude = "";
      this.translate
        .get(["common.attention", "search.search-homepage.pick-valid-location"])
        .subscribe((result) => {
          this.ngxToastrService.typeInfo(
            result["common.attention"],
            result["search.search-homepage.pick-valid-location"]
          );
        });
    }
    this.unFocusInput();
  }

  unFocusInput() {
    if (document.getElementById("address-input") as HTMLElement) {
      (document.getElementById("address-input") as HTMLElement).focus();
    }
    if (this.searchConfig.checkIn && this.searchConfig.checkOut) {
      document.getElementById("date_form").focus();
    } else {
      document.getElementById("date_form").focus();
    }
  }

  getRooms() {
    return this.formRoom.get("room") as UntypedFormArray;
  }


  checkDropdown(dropdown: any, number: number, item: number) {
    this.opened[number][item] = dropdown;
  }

  sendData() {
    let selectedUuids = this.travelers.reduce((acc, val) => acc.concat(val), []);
  
    if (this.uuidUser && !selectedUuids.includes(this.uuidUser)) {
      selectedUuids.unshift(this.uuidUser);
    }
  
    const selectedUsers = selectedUuids
      .map((uuid) => this.companyUsers.find((user) => user.uuid === uuid))
      .filter((user) => user !== undefined);
  
    this.selectedUsers = selectedUsers;

    const projectData = {
      selectedProject: this.selectedProject,
      allProjects: this.projects,
    };
    this.emitSelectedPolicy.emit(this.selectedPolicy);
    this.emitData.emit(this.searchConfig);
    this.emitSelectedUsers.emit(this.selectedUsers);
    this.emitSelectedTravelers.emit(this.travelers);
    this.emitProject.emit(projectData);
  }


  getCompanyUsers() {
    if (!this.companyUuid) {
      this.userService.getUser(this.uuidUser).subscribe(
        (res) => {
          this.companyUuid = res.companyUuid;
          this.fetchCompanyUsers();
        },
        (err) => {}
      );
    } else {
      this.fetchCompanyUsers();
    }
  }

  fetchCompanyUsers() {
    if (this.companyUuid) {
      this.companyService.getCompanyUsers(this.companyUuid).subscribe(
        (res) => {
          this.companyUsers = res.map((user) => ({
            name: user.name,
            lastname: user.lastname,
            uuid: user.uuid,
          }));
          
          this.filteredUsers = this.companyUsers;
          this.setInitialTraveler();
        },
        (err) => {}
      );
    }
  }

  setInitialTraveler() {
    const user = this.companyUsers.find((user) => user.uuid === this.uuidUser);
    if (user) {
      this.defaultUser = user;
      this.companyUsers.filter((u) => u !== this.defaultUser)
      if(!this.travelersSelected){
        if (!this.searchConfig.occupancies.length) {
          this.searchConfig.occupancies.push({
            roomId: 1,
            adults: 1,
            paxes: [],
          });
        }

        if (!this.travelers[0]) {
          this.travelers[0] = [];
        }

        if (!this.travelers[0].includes(user.uuid)) {
          this.travelers[0].unshift(user.uuid);
        }

        this.searchConfig.occupancies[0].adults = this.travelers[0].length;
      }
      this.loadPoliciesForCurrentTravelers();
    }
  }

  onPanelClose() {
    this.filterControl.setValue('');
    this.filteredUsers = this.companyUsers;
  }

  applyFilter(filterValue: string) {
    this.filteredUsers = this.companyUsers.filter(user =>
      `${user.name} ${user.lastname}`.toLowerCase().includes(filterValue.toLowerCase())
    );
  }

  onOpenedChange(isOpened: boolean, input: HTMLInputElement) {
    if (isOpened) {
      setTimeout(() => input.focus(), 0);
    }
  }

  allTravelersSelected(): boolean {
    const allSelected = this.searchConfig.occupancies.every(room => room.adults > 0);
    return allSelected;
  }

  trackByIndex(index: number, item: any): any {
    return index;
  }

  onDateChange() {
    if (this.searchConfig.checkIn && this.searchConfig.checkOut) {
      const checkInParam = this.transformDateToISO(this.searchConfig.checkIn);
      const checkOutParam = this.transformDateToISO(this.searchConfig.checkOut);
      this.loadProjects(checkInParam, checkOutParam);
    }
  }

  loadProjects(checkIn: any, checkOut: any){
    this.loadingProjects = true;

    this.travelService.getTravelsWithParams({ companyUuid: this.companyUuid })
      .subscribe(resp => {
        this.projects = [];
        const defaultProject = {
          title: "--------No-------- ",
          uuid: "none",
        };
        this.projects.push(defaultProject);

        this.projects = this.projects.concat(resp.docs);
        this.projects = this.projects.filter((project) => {
          if (project.initDate && project.endDate) {
            const projectDatesAreCorrect = this.checkDatesAreCorrect(
              checkIn,
              checkOut,
              moment(project.initDate),
              moment(project.endDate)
            );
            return projectDatesAreCorrect;
          } else {
            return true;
          }
        });
        this.selectedProject = defaultProject;
        this.loadingProjects = false;
      }, error => {
        this.loadingProjects = false;
      });
  }

  checkDatesAreCorrect(
    bookingInitDate,
    bookingEndDate,
    projectInitDate,
    projectEndDate
  ) {
    let projectDatesAreCorrect = true;
    if (bookingInitDate != null) {
      const momentInitDate = moment(bookingInitDate);
      projectDatesAreCorrect = moment(projectInitDate).isSameOrBefore(
        momentInitDate,
        "day"
      );
      if (bookingEndDate != null && projectDatesAreCorrect) {
        const momentEndDate = moment(bookingEndDate);
        projectDatesAreCorrect = moment(projectEndDate).isSameOrAfter(
          momentEndDate,
          "day"
        );
      } else {
        if (bookingEndDate == null && projectDatesAreCorrect) {
          projectDatesAreCorrect = moment(projectEndDate).isSameOrAfter(
            momentInitDate,
            "day"
          );
        }
      }
    }
    return projectDatesAreCorrect;
  }

  transformDateToISO(date: { year: number, month: number, day: number }): string {
    const { year, month, day } = date;
    const jsDate = new Date(Date.UTC(year, month - 1, day));
    const datePart = jsDate.toISOString().split('T')[0];
    return `${datePart}T00:00:00.000+00:00`;
  }

  openTravelDialog(){
    const modalRef = this.dialog.open(DialogAssignProjectComponent, {
      data: {
        create: true,
        isOnlyCreate: true,
        userUuid: this.uuidUser,
        companyUuid: this.companyUuid,
      },
      panelClass: "new-dialog",
    });

    modalRef.afterClosed().subscribe((result) => {
      if (result != null) {
        if (this.uuidUser !== null) {
          result.travelData["userUuid"] = this.uuidUser;
        }

        if (this.companyUuid !== null) {
          result.travelData["companyUuid"] = this.companyUuid;
        }
        if (
          result.travelData["endDate"] === "" &&
          result.travelData["initDate"] === ""
        ) {
          delete result.travelData["endDate"];
          delete result.travelData["initDate"];
        }
        this.subcriptions.push(
          this.travelService.postTravel(result.travelData).subscribe(
            (res) => {
              const checkInFormat = moment({
                year: this.searchConfig.checkIn.year,
                month: this.searchConfig.checkIn.month - 1,
                day: this.searchConfig.checkIn.day
              });
              
              const checkOutFormat = moment({
                year: this.searchConfig.checkOut.year,
                month: this.searchConfig.checkOut.month - 1,
                day: this.searchConfig.checkOut.day
              });
              const projectInitDate = moment(res.initDate);
              const projectEndDate = moment(res.endDate);

              const isWithinRange = checkInFormat.isBetween(projectInitDate, projectEndDate, null, '[]')
              && checkOutFormat.isBetween(projectInitDate, projectEndDate, null, '[]');

              if (isWithinRange || (!res.initDate && !res.endDate)) {
                this.projects.push(res);
                this.selectedProject = res;
              }

              this.subcriptions.push(
                this.translate
                  .get(`project.my-projects.created`)
                  .subscribe((resp) => {
                    this.ngxToastrService.typeSuccess(null, resp);
                    setTimeout(() => {
                    }, 3000);
                  })
              );
            },
            (err) => {
              this.subcriptions.push(
                this.translate.get("common.error").subscribe((resp) => {
                  this.ngxToastrService.typeInfo(resp, err.error.message);
                })
              );
            }
          )
        );
      }
    });
  }

  toggleRoomModal() {
    this.roomModalOpen = !this.roomModalOpen;
  }

  addRoom() {
    const newRoom = {
      rooms: 1,
      adults: 0,
      paxes: [],
    };
    this.searchConfig.occupancies.push(newRoom);
    this.travelers.push([]);
  }

  removeRoom(index: number) {
    if (index === 0) {
      return;
    }
  
    if (this.searchConfig.occupancies.length > 1) {
      this.searchConfig.occupancies.splice(index, 1);
      this.travelers.splice(index, 1);
    }
  }
  
  addTraveler(roomIndex: number, travelerUuid: string) {
    if (!this.travelers[roomIndex]) {
      this.travelers[roomIndex] = [];
    }
  
    if (!this.travelers[roomIndex].includes(travelerUuid)) {
      this.travelers[roomIndex].push(travelerUuid);
      this.searchConfig.occupancies[roomIndex].adults = this.travelers[roomIndex].length;
    }
    this.loadPoliciesForCurrentTravelers();
  
    setTimeout(() => {
      this.selectedTraveler[roomIndex] = null;
    });
  }

  removeTraveler(roomIndex: number, travelerIndex: number) {
    if (!this.travelers[roomIndex]) {
      return;
    }
  
    this.travelers[roomIndex].splice(travelerIndex, 1);
    this.searchConfig.occupancies[roomIndex].adults = this.travelers[roomIndex].length;
    this.loadPoliciesForCurrentTravelers();
  }
  


  getTravelerName(uuid: string): string {
    const traveler = this.companyUsers.find(user => user.uuid === uuid);
    return traveler ? `${traveler.name} ${traveler.lastname}` : '';
  }
  

  getAvailableUsers(): { name: string; lastname: string; uuid: string }[] {
    return Array.isArray(this.companyUsers) ? this.companyUsers : [];
  }

  getOccupancySummary() {
    let totalPersons = this.searchConfig.occupancies.reduce((sum, room) => sum + (room.adults || 0), 0);
    return `${totalPersons} ${this.translate.instant("hotel.custom.people")}, ${this.searchConfig.occupancies.length} ${this.translate.instant("hotel.custom.rooms")}`;

  }

  trackByUuid(index: number, user: { uuid: string }): string {
    return user.uuid;
  }

  closeRoomModal() {
    this.roomModalOpen = false;
  }

  private getAllTravelerUuids(): string[] {
    const set = new Set<string>();

    (this.travelers || []).forEach(room => {
      (room || []).forEach(uuid => {
        if (uuid) {
          set.add(uuid);
        }
      });
    });

    return Array.from(set);
  }

  private loadPoliciesForCurrentTravelers(): void {
    const travelerUuids = this.getAllTravelerUuids();
    const requestKey = travelerUuids.slice().sort().join('|');
    this.lastPoliciesRequestKey = requestKey;

    if (!travelerUuids.length) {
      this.policies = [];
      this.selectedPolicy = null;
      this.loadingPolicies = false;
      return;
    }

    if (this.policiesSub) {
      this.policiesSub.unsubscribe();
      this.policiesSub = undefined;
    }

    this.loadingPolicies = true;

    const requests = travelerUuids.map(userUuid => {
      if (this.userPoliciesCache[userUuid]) {
        return of(this.userPoliciesCache[userUuid]);
      }

      return this.userService.getPoliciesUser(userUuid).pipe(
        tap(policies => {
          this.userPoliciesCache[userUuid] = policies || [];
        }),
        catchError(err => {
          this.userPoliciesCache[userUuid] = [];
          return of([]);
        })
      );
    });

    this.policiesSub = forkJoin(requests).subscribe({
      next: (results: any[][]) => {
        if (this.lastPoliciesRequestKey !== requestKey) {
          return;
        }

        const allPolicies = results.reduce(
          (acc: any[], arr: any[]) => acc.concat(arr || []),
          []
        );

        const unique: any[] = [];
        const seen = new Set<string>();

        for (const p of allPolicies) {
          const id = p.uuid || p._id || p.name;
          if (!id) continue;
          if (!seen.has(id)) {
            seen.add(id);
            unique.push(p);
          }
        }

        const canUseHotelPolicy = (p: any) => {
          if (this.isAdmin) return true;

          return p?.filters?.requestBooked !== false;
        };

        this.policies = unique.filter(canUseHotelPolicy);

        const getId = (p: any) => p && (p.uuid || p._id || p.name);
        const currentSelectedId = getId(this.selectedPolicy);

        if (currentSelectedId) {
          const matched = this.policies.find((p) => getId(p) === currentSelectedId);
          this.selectedPolicy = matched ?? null;
        }

        if (!this.selectedPolicy) {
          const cachedForDefault = this.userPoliciesCache[this.defaultUser?.uuid];
          const defaultPolicy = Array.isArray(cachedForDefault) ? cachedForDefault[0] : cachedForDefault;

          const defaultValid =
            (defaultPolicy && this.policies.find((p) => getId(p) === getId(defaultPolicy))) ||
            this.policies[0] ||
            null;

          this.selectedPolicy = defaultValid;
        }
        this.userFilters = this.selectedPolicy?.filters || this.userFilters;
        this.applyPolicyDateConstraints();
        this.loadingPolicies = false;
      },
      error: _ => {
        if (this.lastPoliciesRequestKey !== requestKey) {
          return;
        }

        this.loadingPolicies = false;
        this.policies = [];
        this.selectedPolicy = null;
      }
    });

    this.subcriptions.push(this.policiesSub);
  }

  ngOnDestroy() {
    this.isPackageRate = null;
    if (this.subcriptions) {
      this.subcriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }

  changePackageRate() {
    this.isPackageRate = this.isPackageRate === 'accommodation' ? null : this.isPackageRate = 'accommodation'
    localStorage.setItem('isPackageRate', this.isPackageRate);
    this.emitPackageRate.emit(this.isPackageRate);
  }

  onPolicyChange(policy: any) {
    this.selectedPolicy = policy;
    this.userFilters = policy?.filters || this.userFilters;
    this.applyPolicyDateConstraints();
    this.onDateChange();
  }

  private applyPolicyDateConstraints(): void {
    const minIn = this.getInMinDate();
    const minInMoment = moment({ year: minIn.year, month: minIn.month - 1, day: minIn.day });

    if (this.searchConfig.checkIn) {
      const checkInMoment = moment({
        year: this.searchConfig.checkIn.year,
        month: this.searchConfig.checkIn.month - 1,
        day: this.searchConfig.checkIn.day,
      });

      if (checkInMoment.isBefore(minInMoment, "day")) {
        this.searchConfig.checkIn = null;
        this.searchConfig.checkOut = null;
      }
    }

    if (this.searchConfig.checkIn && this.searchConfig.checkOut) {
      const outMin = this.getOutMinDate();
      const outMinMoment = moment({ year: outMin.year, month: outMin.month - 1, day: outMin.day });

      const checkOutMoment = moment({
        year: this.searchConfig.checkOut.year,
        month: this.searchConfig.checkOut.month - 1,
        day: this.searchConfig.checkOut.day,
      });

      if (checkOutMoment.isBefore(outMinMoment, "day")) {
        this.searchConfig.checkOut = null;
      }
    }
  }

}
